import React from 'react'
import cookie from 'react-cookies'
import useMediaQuery from '@mui/material/useMediaQuery'
import { layoutMobileMediaQuery } from '../../layout/layoutConstants'
import { getOrderPaymentAttachmentValues } from '../../order/helpers/orderDetailsHelpers'

import {
  buildRefundSummaryFields,
  buildRefundFields,
  parseRefundProductDetails
} from './shared/refundDetailsHelpers'
import RefundSalesmanDetailsDesktop from './desktop/RefundSalesmanDetailsDesktop'
import RefundSalesmanDetailsMobile from './mobile/RefundSalesmanDetailsMobile'

export default function RefundSalesmanDetailsTab({
  activity = {},
  statusUI,
  showStatusInHeader = false
}) {
  const taxSettings = cookie.load('tax_settings') || {}
  const isMobileLayout = useMediaQuery(layoutMobileMediaQuery)
  const customFields = Array.isArray(activity.custom_fields) ? activity.custom_fields : []
  const summaryFields = buildRefundSummaryFields(activity)
  const fieldsToRender = buildRefundFields(activity, customFields)
  const paymentAttachments = getOrderPaymentAttachmentValues(customFields)
  const { processedDetails, extraColumns } = parseRefundProductDetails(activity.details)
  const totalRows = [
    {
      label: 'SUB-TOTAL:',
      value: activity.subtotal
    },
    taxSettings.tax_rate_2 && {
      label: `${taxSettings.tax_rate_2}:`,
      value: 0
    },
    {
      label: `${taxSettings.tax_rate}:`,
      value: activity.taxes
    },
    {
      label: 'TOTAL:',
      value: activity.total,
      strong: true,
      dividerBefore: true
    },
    {
      label: 'PESO TOTAL:',
      value: activity.total_weight
    }
  ]

  const headerData = {
    ...activity,
    display_created_date: activity.created_date || activity.created_at || activity.collected_at
  }

  if (isMobileLayout) {
    return (
      <RefundSalesmanDetailsMobile
        activity={activity}
        statusUI={statusUI}
        summaryFields={summaryFields}
        fieldsToRender={fieldsToRender}
        paymentAttachments={paymentAttachments}
        processedDetails={processedDetails}
        extraColumns={extraColumns}
        totalRows={totalRows}
      />
    )
  }

  return (
    <RefundSalesmanDetailsDesktop
      headerData={headerData}
      summaryFields={summaryFields}
      fieldsToRender={fieldsToRender}
      paymentAttachments={paymentAttachments}
      processedDetails={processedDetails}
      extraColumns={extraColumns}
      totalRows={totalRows}
    />
  )
}
